import { Component, Input, OnInit } from '@angular/core';
import * as Constants from "../../utils/Constants";
import { StorageService } from 'src/app/services/storage.service';
import { ModalController } from '@ionic/angular';
import { ModalHelperService } from 'src/app/services/modal-helper';
import { TranslateService } from '@ngx-translate/core';
import { roundTwoValuePositions } from '../../utils/Constants';
import { calcDeltaUw, calcPsi, muntinSpacerExists } from 'src/app/utils/calculation';
import { CalculationAutoUpdateService } from 'src/app/services/calculation-auto-update.service';
type ConfigType = 'basic' | 'manual';

@Component({
  selector: 'app-edit-georgian-bar-config',
  templateUrl: './edit-georgian-bar-config.component.html',
  styleUrls: ['./edit-georgian-bar-config.component.scss'],
  standalone: false,
})
export class EditGeorgianBarConfigComponent implements OnInit {
  @Input() isComparisonMode: boolean = false;
  data_muntin_spacer = Constants.data_muntin_spacer;
  showConfig: boolean = true;
  configType: ConfigType = 'basic';
  muntinspacers1: any = "0000";
  muntinspacers2: any = "0011";
  muntinspacers3: any = "0001";
  muntinspacers4: any = "0001";
  glassGlazing = 0;
  storedProject: any;

  eManMuntinSpacerPsi: number = 0;
  eManMuntinSpacerName = "man";
  isFormValid = true;

  constructor(private modalController: ModalController, private storageService: StorageService,
    private modalHelper: ModalHelperService, private translate: TranslateService, private calcAutoUpdate: CalculationAutoUpdateService
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {
    this.init();
  }

  private async init(): Promise<void> {
    try {
      const res = this.isComparisonMode
        ? await this.storageService.getComparedProject()
        : await this.storageService.getProject();
      this.storedProject = res ? JSON.parse(res) : null;

      if (this.storedProject?.muntin) {
        const muntin = this.storedProject.muntin;
        this.configType = muntin.configType || 'basic';
        if (this.storedProject?.windowglas) {
          const glass = this.storedProject.windowglas;

          if (muntin?.muntinspacers1) {
            this.muntinspacers1 = muntin.muntinspacers1;
            if (muntin.muntinspacers1 == '0001') {
              this.muntinspacers2 = muntin.muntinspacers2;
              this.muntinspacers3 = muntin.muntinspacers3;
              this.muntinspacers4 = muntin.muntinspacers4;
            }
          }
          if (muntin.spacer) {
            if (glass.glazingCount === 4 ||
              muntinSpacerExists(muntin.spacer) == false
            ) {
              // this.translate.get(muntin.spacer).subscribe((translation: string) => {
              //   this.eManMuntinSpacerName = translation;
              // });
            } else {
              // this.eManMuntinSpacerName = "man"
              // this.eManMuntinSpacerPsi = calcPsi('MUNTINSPACER_ALU_DOUBLE_2MM')
            }
            this.eManMuntinSpacerPsi = muntin.psi;
            if (glass.glazingCount === 4) {
              this.showConfig = false;
              this.configType = 'manual';
            } else {
              this.showConfig = true;
            }
            if (this.configType == 'manual') {
              this.eManMuntinSpacerName = muntin.spacer;

            }
          }
          if (this.storedProject?.windowglas?.glazingCount) {
            this.glassGlazing = this.storedProject.windowglas.glazingCount || this.storedProject['windowglas']['glazingCount'];
          }
        }
      }
    } catch (error) {
      console.error('Error initializing spacer data:', error);
    }
  }

  onModeChange(event: CustomEvent) {
    const value = event.detail.value as string | undefined;
    if (value === 'basic' || value === 'manual') {
      this.configType = value;
    }
    if (value === 'basic') {
      this.isFormValid = true;
    } else {
      this.validateForm()
    }
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  private async saveToStorage(payload: any): Promise<void> {
    if (this.isComparisonMode) {
      await this.storageService.updateComparedProject(payload);
    } else {
      await this.storageService.updateProject(payload);
      await this.calcAutoUpdate.triggerAutoUpdate('glass', this.isComparisonMode);
    }
  }

  async next() {

    if (this.configType == 'basic') {
      const selResult = this.data_muntin_spacer.find((obj: any) => obj.config == this.muntinspacers4)?.name;
      var muntin = this.storedProject.muntin
      muntin.spacer = selResult;
      muntin.muntinspacers1 = this.muntinspacers1;
      if (this.storedProject?.windowglas) {
        this.glassGlazing = this.storedProject.windowglas?.glazingCount || this.storedProject['windowglas']['glazingCount'];
      }
      if (this.muntinspacers1 == '0001') {
        muntin.muntinspacers2 = this.muntinspacers2; //0011 - plastic  0001- Aluminium
        muntin.muntinspacers3 = this.muntinspacers3;
        muntin.muntinspacers4 = this.muntinspacers4;
        if (this.glassGlazing == 2) {
          if (this.muntinspacers2 == '0011' && this.muntinspacers4 == '0001') {
            muntin.spacer = "MUNTINSPACER_PLASTIC_2MM";
          } else if (this.muntinspacers2 == '0011' && this.muntinspacers4 == '1001') {
            muntin.spacer = "MUNTINSPACER_PLASTIC_4MM";
          } else if (this.muntinspacers2 == '0001' && this.muntinspacers4 == '0001') {
            muntin.spacer = "MUNTINSPACER_ALU_2MM";
          } else if (this.muntinspacers2 == '0001' && this.muntinspacers4 == '1001') {
            muntin.spacer = "MUNTINSPACER_ALU_4MM";
          }
        } else if (this.glassGlazing == 3 && this.muntinspacers3 == '0001') {
          if (this.muntinspacers2 == '0011' && this.muntinspacers4 == '0001') {
            muntin.spacer = "MUNTINSPACER_PLASTIC_SINGLE_2MM";
          } else if (this.muntinspacers2 == '0011' && this.muntinspacers4 == '1001') {
            muntin.spacer = "MUNTINSPACER_PLASTIC_SINGLE_4MM";
          } else if (this.muntinspacers2 == '0001' && this.muntinspacers4 == '0001') {
            muntin.spacer = "MUNTINSPACER_ALU_SINGLE_2MM";
          } else if (this.muntinspacers2 == '0001' && this.muntinspacers4 == '1001') {
            muntin.spacer = "MUNTINSPACER_ALU_SINGLE_4MM";
          }
        } else if (this.glassGlazing == 3 && this.muntinspacers3 == '0101') {
          if (this.muntinspacers2 == '0011' && this.muntinspacers4 == '0001') {
            muntin.spacer = "MUNTINSPACER_PLASTIC_DOUBLE_2MM";
          } else if (this.muntinspacers2 == '0011' && this.muntinspacers4 == '1001') {
            muntin.spacer = "MUNTINSPACER_PLASTIC_DOUBLE_4MM";
          } else if (this.muntinspacers2 == '0001' && this.muntinspacers4 == '0001') {
            muntin.spacer = "MUNTINSPACER_ALU_DOUBLE_2MM";
          } else if (this.muntinspacers2 == '0001' && this.muntinspacers4 == '1001') {
            muntin.spacer = "MUNTINSPACER_ALU_DOUBLE_4MM";
          }
        }
      } else {
        muntin.muntinspacers2 = null;
        muntin.muntinspacers3 = null;
        muntin.muntinspacers4 = null;
        muntin.spacer = "MUNTINSPACER_FIXED_ADDITION";
      }
      muntin.psi = calcPsi(muntin.spacer);
      muntin.configType = this.configType;
      await this.saveToStorage({
        "muntin": muntin,
      });
    } else if (this.configType == 'manual') {
      await this.saveToStorage({
        "muntin": {
          "psi": this.eManMuntinSpacerPsi,
          "spacer": this.eManMuntinSpacerName,
          "shape": this.storedProject.muntin.shape,
          "type": this.storedProject.muntin.type,
          "configType": this.configType,
          "muntinspacers1": this.storedProject.muntin.muntinspacers1,
          "muntinspacers2": this.storedProject.muntin.muntinspacers2,
          "muntinspacers3": this.storedProject.muntin.muntinspacers3,
          "muntinspacers4": this.storedProject.muntin.muntinspacers4
        }
      });
    }
    const resUW = 'ΔUw = ' + roundTwoValuePositions(calcDeltaUw(this.storedProject)) + " W/m²K";
    console.log(resUW);
    //close all modals
    await this.modalHelper.closeAllModals({}, 'confirm');
  }

  validateForm(): void {
    // Check if required fields have values
    const hasName = this.eManMuntinSpacerName !== null && this.eManMuntinSpacerName !== undefined && this.eManMuntinSpacerName !== "";
    const hasPsi = this.eManMuntinSpacerPsi !== null && this.eManMuntinSpacerPsi !== undefined;

    this.isFormValid = hasName && hasPsi;
  }

  private findDataById(arrayData: any, id: number): any {
    return arrayData.find((obj: any) => obj.id === id);
  }

}
